import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production || environment.qa) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(_err => {
  });
